import React from "react";
import { aboutCopy, brand, modalities } from "../mock";

const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden">
      <div className="cosmic-bg absolute inset-0" />
      <div className="stars stars-twinkle" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-14 items-start">
        <div className="md:col-span-5">
          <div className="relative">
            <div className="absolute -inset-8 rounded-[40px] border border-[#D4A85B]/20 hidden md:block" />
            <div className="relative aspect-square rounded-[24px] overflow-hidden border border-[#D4A85B]/30 shadow-[0_30px_80px_-20px_rgba(212,168,91,0.3)] bg-gradient-to-b from-[#1A0E30] to-[#0A0714]">
              <img
                src={brand.profileImage}
                alt="Devona Nicole Hazelwood, LPC, NCC, Reiki Master"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0714] via-transparent to-transparent opacity-55 pointer-events-none" />
              <div className="absolute inset-x-0 bottom-0 p-6 z-10">
                <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]">A note from Devona</div>
                <div className="mt-3 font-serif italic text-[22px] text-[#EDE3D0] leading-snug">
                  “You are not broken. You have adapted, now let’s do it in a better way.”
                </div>
              </div>
            </div>
          </div>

          {/* Modalities chip cloud */}
          <div className="mt-8">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#D4A85B]/80">Modalities woven together</div>
            <div className="mt-4 flex flex-wrap gap-2">
              {modalities.map((m) => (
                <span
                  key={m}
                  className="text-xs px-3 py-1.5 rounded-full border border-[#D4A85B]/30 text-[#EDE3D0]/85 bg-[#D4A85B]/[0.04]"
                >
                  {m}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="md:col-span-7">
          <div className="divider-star"><span>{aboutCopy.eyebrow}</span></div>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] mt-6 text-[#EDE3D0]">
            {aboutCopy.title}
          </h2>
          <div className="mt-3 text-[11px] uppercase tracking-[0.34em] text-[#D4A85B]">
            {brand.credentials}
          </div>

          <div className="mt-8 space-y-5 text-[#EDE3D0]/85 text-lg leading-relaxed">
            <p>{aboutCopy.intro}</p>
            {aboutCopy.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <p className="font-serif italic text-[#D4A85B] text-xl">{aboutCopy.closing}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
